import { ApiUser, User } from './user.types'

export function parseApiUser(user: ApiUser): User {
  return user
}
